import { requestJson } from "./instateamEmployeeApi";

export function getEmployeeAttendanceOverview(token, monthKey) {
  const searchParams = new URLSearchParams();
  if (monthKey) {
    searchParams.set("month", monthKey);
  }

  return requestJson(`/instateam/attendance/employee/overview?${searchParams.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function checkInEmployeeAttendance(token, payload = {}) {
  return requestJson("/instateam/attendance/employee/check-in", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function checkOutEmployeeAttendance(token) {
  return requestJson("/instateam/attendance/employee/check-out", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function requestEmployeeAttendanceRegularization(token, payload) {
  return requestJson("/instateam/attendance/employee/regularization", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function requestEmployeeCompOff(token, payload) {
  return requestJson("/instateam/attendance/employee/comp-off", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
